const { getAxiosInstance } = require('../connection');

module.exports = {
    create: function (eventId, data) {
        return getAxiosInstance({
            method: 'POST',
            url: ['', 'events', encodeURIComponent(eventId), 'programs'].join('/'),
            data: {
                is_task: true,
                ...data,
            },
        }).then((response) => response.data);
    },
    update: function (eventId, programId, data, { sendPush } = {}) {
        return getAxiosInstance({
            method: 'PUT',
            url: ['', 'events', encodeURIComponent(eventId), 'programs', encodeURIComponent(programId)].join('/'),
            data: {
                ...data,
                send_push: !!sendPush,
            },
        }).then((response) => response.data);
    },
    delete: function (eventId, programId) {
        return getAxiosInstance({
            method: 'DELETE',
            url: ['', 'events', encodeURIComponent(eventId), 'programs', encodeURIComponent(programId)].join('/'),
        }).then((response) => response.data);
    },
    assign: function (eventId, assign = [], options = {}) {
        return getAxiosInstance({
            method: 'POST',
            url: ['', 'events', encodeURIComponent(eventId), 'assign_program_roles'].join('/'),
            data: {
                send_push: !!options.sendPush,
                assign,
            },
        });
    },
};
